import { LANDING_PAGE_STATUS } from '../consts/landingPageStatus';
import { LANDING_PAGE_URLS } from '../consts/urls';

export const getLandingPageUrl = ({
    accountId,
    slug,
    status,
    isPreview = false,
    landingPageId,
    versionNumber,
    totalVersions,
    publishedVersionNumber,
}) => {
    const baseUrl = isPreview ? LANDING_PAGE_URLS.PREVIEW : LANDING_PAGE_URLS.PRODUCTION;
    const hasVersionData = landingPageId && versionNumber !== undefined && totalVersions > 1;
    const isViewingPublishedVersion = publishedVersionNumber !== undefined && versionNumber === publishedVersionNumber;
    const shouldUseVersionUrl = isPreview && hasVersionData && !isViewingPublishedVersion;

    if (shouldUseVersionUrl) {
        return `${baseUrl}${accountId}%2Fdraft/${landingPageId}/${versionNumber}`;
    }

    const folder = isPreview || status === LANDING_PAGE_STATUS.DRAFT ? `/${status?.toLowerCase()}` : '';
    return `${baseUrl}${accountId}${folder}/${slug}`;
};
